import axios from 'axios';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BurnerJob } from 'reducers/printersReducer';
import React from 'react';
import { StudyToBurn } from 'reducers/studiesToBurnReducer';

export const tooltipped = (text, tooltipText = text) => (
  <OverlayTrigger placement="bottom" overlay={tooltip(tooltipText)} delay={300}>
    <div id="tooltippedBurnOverlay" style={{ width: 'min-content' }}>
      {text}
    </div>
  </OverlayTrigger>
);

export const ellipseTooltipped = (text, tooltipText = text) => (
  <OverlayTrigger placement="bottom" overlay={tooltip(tooltipText)} delay={300}>
    <div id="tooltippedBurnOverlay" style={{ width: 'inherit' }}>
      {text}
    </div>
  </OverlayTrigger>
);

export const tooltip = text => <Tooltip id="tooltip">{text}</Tooltip>;

export function isPriorityChangeable(burnerJob) {
  if (
    burnerJob.burner === 'UNKNOWN' ||
    // rimage status check
    burnerJob.burnerModel === 'RIMAGE_2000I' ||
    //epson status check
    (burnerJob.burnerModel === 'EPSON_P100' &&
      (parseInt(burnerJob.statusCode) > 2 ||
        // epson detailed statuses
        parseInt(burnerJob.detailedStatus) > 2))
  ) {
    return false;
  }
  return true;
}

export const handleUpdatePriority = (
  burnerJob: BurnerJob,
  priority: string | null,
  toaster: { success(message: any): void; info(message: any): void; warning(message: any): void; error(message: any): void }
): void => {
  if (priority === '-') {
    priority = null;
  }
  axios
    .get(`/rest/react/updateJobPriority`, {
      params: {
        jobId: burnerJob.id,
        printer: burnerJob.burner,
        priority: priority,
      },
      headers: {
        'Content-type': 'application/json',
      },
    })
    .then(() => {
      toaster.success('Priority updated correctly');
      burnerJob.priority = priority;
    })
    .catch(e => toaster.error(e.message));
};

export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(item => deepClone(item)) as unknown as T;
  }
  const clonedObj: any = {};
  Object.keys(obj).forEach(key => {
    clonedObj[key] = deepClone(obj[key]);
  });
  return clonedObj;
}

export function setupOriginalJob(superJob: BurnerJob | undefined, job: BurnerJob, support: BurnerJob[]): BurnerJob {
  let originalJob: BurnerJob | undefined = undefined;
  let originalJobStudiesUids: Array<string> = [];
  if (superJob === undefined) {
    originalJob = {
      id: job.id,
      burner: job.burner,
      burnerModel: job.burnerModel,
      reader: job.reader,
      date: job.date,
      patientName: job.patientName,
      studies: [] as StudyToBurn[],
      statusDescription: job.statusDescription,
      statusCode: job.statusCode,
      detailedStatus: job.detailedStatus,
      detailedStatusDescription: job.detailedStatusDescription,
      errorDescription: job.errorDescription,
      errorCode: job.errorCode,
      priority: job.priority,
      linkedJobId: job.linkedJobId,
      filteredInstances: job.filteredInstances,
    };
    let studies: StudyToBurn[] = [];
    copyStudies(job, originalJobStudiesUids, studies);
    originalJob.studies.push(...studies);
  } else {
    originalJob = deepClone(superJob);
    originalJob.studies.forEach(study => {
      if (!originalJobStudiesUids.includes(study.studyUid!)) {
        originalJobStudiesUids.push(study.studyUid!);
      }
    });
  }
  support.forEach(subJob => {
    copyStudies(subJob, originalJobStudiesUids, originalJob!.studies);
  });
  return originalJob;
}
function copyStudies(job: BurnerJob, studiesUidList: Array<string>, presentStudies: Array<StudyToBurn>) {
  job.studies.forEach(study => {
    if (studiesUidList.includes(study.studyUid!)) {
      const studyListed: StudyToBurn | undefined = presentStudies.find(alreadyInsertedStudy => {
        return alreadyInsertedStudy.studyUid === study.studyUid;
      });
      if (studyListed !== undefined) {
        study.series?.forEach(series => {
          if (!studyListed.series?.includes(series)) {
            studyListed.series?.push(series);
            studyListed.totalSeries! += 1;
          }
        });
      }
    } else {
      presentStudies.push(deepClone(study));
      studiesUidList.push(study.studyUid!);
    }
  });
}
